import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';

class TabPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.clk = this.clk.bind(this);
    }

    clk(index) {
        return (e) => {
            this.context.changeState('index', index);
        };
    }

    render() {
        const { children, className } = this.props;
        const { index } = this.context;
        let selNode;
        Children.forEach(children, (item, n) => {
            if (n == index) {
                selNode = item;
            }
        });
        return (
            <div className={className}>
                {selNode}
            </div>
        );
    }
}
TabPanel.propTypes = {
    className: PropTypes.string
};
TabPanel.contextTypes = {
    index: PropTypes.number
};
export default TabPanel;



// WEBPACK FOOTER //
// ./client/component/tab/panel.js